// Third-party Library
import React from "react";
import { Card, Tag } from "antd";

// Styles
import styles from './index.module.css'

const StatCard = ({ label, value, bigText, badge, footnote, footnoteColor }) => {

    return (
        <Card
            bordered={false}
            className={styles["container-card"]}
            styles={{ body: { padding: "18px 18px" }}}
        >
            <div className={styles["title"]}>{label}</div>
            <div className={styles["container-content"]}>
                {
                    bigText ? 
                        <span className={styles["big-text"]} style={{ color: bigText.color }}>{bigText.text}</span>
                    : 
                        <>
                            <span style={{ fontSize: 28, fontWeight: 800, color: "#111827" }}>{value}</span>
                            { badge && <Tag color={badge.color} >{badge.text}</Tag> }
                        </>
                }
            </div>
            <div className={styles["footnote"]} style={{ color: footnoteColor }}>{footnote}</div>
        </Card>
    );
}

export default React.memo(StatCard)